import { useRef } from 'react'

import { Markdown, ScrollToBottomButton } from '@ui/components'

import { useArtifactContext } from './Artifact'

export default function Content() {
	const { artifactParams, isProcessingResponse, artifactContent, onSourceSelected } = useArtifactContext()
	const { artifactMessage } = artifactParams
	const contentRef = useRef<HTMLDivElement>(null)

	return (
		<>
			<div ref={ contentRef } className="p-6 ml-8 chat-message artifact h-full overflow-y-scroll">
				<Markdown
					contents={ artifactMessage.contents }
					isWriting={ isProcessingResponse }
					onSourceSelected={ onSourceSelected }
				>
					{ artifactContent ?? '' }
				</Markdown>
			</div>
			<ScrollToBottomButton
				origin="artifact"
				parentRef={ contentRef } />
		</>
	)
}
